import * as React from 'react';
import { connect } from 'react-redux';
import { Form, Button, Row, Col, FormGroup } from 'react-bootstrap';
import { Multiselect } from 'multiselect-react-dropdown';
import Moment from 'moment';
import { extendMoment } from 'moment-range';
import { getTableValuesByGroupName } from '../../../services/Utils/IndexedDBUtils';
import Api from '../../../services/Api';
import { ApiResponse } from 'apisauce';
import * as urls from '../../shared/urls';
import { Grid } from 'react-flexbox-grid';
import { showLoadingWithMessage } from '../../Application/redux-objects/actions';
import styled from 'styled-components';
import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import PagedDatatable from '../../PagedDataTable';
import { IExportColumnMap, PagedResultsRequest } from '../../../common/sharedTypes';
import { TableColumn } from "react-data-table-component/dist/DataTable/types";
import { CaseStudySearchItem, ICaseStudySearchPagedResponse } from '../business-objects/common';
import { getSearchResults, setSelectedRowsChangedR, getExportData, doExport } from '../redux-objects/actions';
import { QueuedNotificationSearchItem } from '../../NotificationQueue/business-objects/common';

const moment = extendMoment(Moment);

interface ICaseStudySearchProps {
  showLoadingWithMessage: (show: boolean, message?: string) => void;
  setSelectedRowsChangedR: (rows: any) => void;
  loading: boolean;
  searchResults: ICaseStudySearchPagedResponse;
  getSearchResults: (url: string, request: any) => void;
}

class CaseStudySearch extends React.Component<ICaseStudySearchProps, any> {
  //resultsTable: DataTable;

  objectTypes = [];
  directionOfTravel = [
    { text: 'N', value: '01' },
    { text: 'E', value: '03' },
    { text: 'S', value: '02' },
    { text: 'W', value: '04' },
  ];




  options = {
    dom: '<if<t>lp>',
  };

  directionOfTravelRef: React.RefObject<Multiselect>;
  sequenceOfEventsRef: React.RefObject<Multiselect>;
  firstHarmfulEventRef: React.RefObject<Multiselect>;

  public constructor(props: ICaseStudySearchProps) {
    super(props);

    this.state = {
      crashStartDate: null,
      crashEndDate: null,
      crashKey: '',
      highwayNumber: '',
      referencePostFrom: '',
      referencePostTo: '',
      latitudeFrom: '',
      latitudeTo: '',
      longitudeFrom: '',
      longitudeTo: '',
      sequenceOfEvents: [],
      firstHarmfulEvents: [],
      selectedCounty: -1,
      selectedCity: -1,
      selectedObjectType: -1,
      selectedDirectionOfTravel: [],
      eventData: [],
      counties: [],
      objectType: [],
      cities: [],
      firstHarmfulEventData: [],
      dbToSearch: 'private',
      showResultsBy: 'crashes',
      showSelectedResultDetails: false,
      crashSeverityTotals: { fatal: 0, injA: 0, injB: 0, injC: 0, pdo: 0, unk: 0, nr: 0, ns: 0 },
      locationLine1: '',
      locationLine2: '',
      showCrashKeyError: false,
      selectAll: false,
      crashPagingCriteria: {
        itemsPerPage: 10,
        pageNumber: 1,
        searchCriteria: null,
        orderByField: "",
        orderDescending: false,
        export: false
      },
      vehiclePagingCriteria: {
        itemsPerPage: 500,
        pageNumber: 1,
        searchCriteria: null,
        orderByField: "",
        orderDescending: false,
        export: false
      },
      selectedCrashRowIds: [],
      selectedCrashRowsOnPage: [],
      selectedVehicleRows: [],
      selectedVehicleRowIds: []
    };

    getTableValuesByGroupName('County').then((results) =>
      this.setState({ counties: results })
    );
    getTableValuesByGroupName('ObjectType').then((results) =>
      this.setState({
        objectType: results.sort((a, b) => {
          return a.description.toUpperCase() < b.description.toUpperCase()
            ? -1
            : 1;
        })
      })
    );
    getTableValuesByGroupName('SequenceOfEvents').then((results) =>
      this.setState({
        eventData: results.sort((a, b) => {
          return a.description.toUpperCase() < b.description.toUpperCase()
            ? -1
            : 1;
        })
      })
    );
    getTableValuesByGroupName('MostHarmfulEvent').then((results) =>
      this.setState({
        firstHarmfulEventData: results.sort((a, b) => {
          return a.description.toUpperCase() < b.description.toUpperCase()
            ? -1
            : 1;
        })
      })
    );

    Api.get(urls.GET_COUNTY_CITIES).then((response: ApiResponse<any>) => {
      if (response.ok) this.setState({ cities: response.data });
    });

    this.directionOfTravelRef = React.createRef();
    this.sequenceOfEventsRef = React.createRef();
    this.firstHarmfulEventRef = React.createRef();
  }

  handleStateChange = (key, value) => {
    var newstate = {};
    newstate[key] = value;
    this.setState(newstate, () => {
      if (key == 'showResultsBy')
        this.setState({
          searchResults: this.props.searchResults
            ? this.state.showResultsBy == 'crashes'
              ? this.props.searchResults.crashes
              : this.props.searchResults.vehicles
            : [],
        });
    });
  };

  handleCrashKeyBlur = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ showCrashKeyError: (!(event.currentTarget.value.length == 9 || event.currentTarget.value.length == 0)) });
  };

  handleCrashKeyChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.currentTarget.value.length <= 9) {
      this.handleStateChange("crashKey", event.currentTarget.value);
      if (this.state.showCrashKeyError) {
        this.setState({ showCrashKeyError: (!(event.currentTarget.value.length == 9 || event.currentTarget.value.length == 0)) });
      }
    }
  };

  handleCrashKeyKeyDown = (e: any) => {
    const exceptThisSymbols = ["e", "E", "+", "-", "."];
    exceptThisSymbols.includes(e.key) && e.preventDefault()
  }

  handleMultiSelectAdd = (key, value) => {
    var newstate = {};
    newstate[key] = [...this.state[key], value];
    this.setState(newstate);
  };

  handleMultiSelectRemove = (key, value) => {
    var newstate = {};
    newstate[key] = [...this.state[key]].filter((item) => item != value);
    this.setState(newstate);
  };

  getFilteredCities = () => {
    if (this.state.cities.length > 0) {
      if (this.state.selectedCounty < 0)
        return this.state.cities.map((item) => {
          return {
            name: item.city.name,
            description: item.city.description,
          };
        });
      else {
        return this.state.cities
          .filter((item) => item.county.name == this.state.selectedCounty)
          .map((item) => {
            return {
              name: item.city.name,
              description: item.city.description,
            };
          });
      }
    } else
      return [];
  };

  executeSearch = () => {
    //console.debug("before search selected crash rows", this.state.selectedCrashRowsOnPage);
    const searchRequest = this.buildSearchRequest();
    this.props.getSearchResults(urls.EXECUTE_CASE_STUDY_SEARCH, searchRequest)
  };

  buildSearchRequest = () => {
    const searchRequest = { ...this.state.crashPagingCriteria };
    const propsToIgnore = [
      'firstHarmfulEventData',
      'searchResults',
      'eventData',
      'cities',
      'counties',
      'objectType',
      'selectedCrashRowsOnPage',
      'selectedVehicleRows',
      'selectedCrashRowIds',
      'selectedVehicleRowIds'
    ];
    for (const prop in this.state) {
      if (propsToIgnore.indexOf(prop) == -1) {
        if (
          (this.state[prop] &&
            Array.isArray(this.state[prop]) &&
            this.state[prop].length > 0) ||
          (typeof this.state[prop] === 'string' && this.state[prop] != '') ||
          (typeof this.state[prop] === 'number' && this.state[prop] != -1) ||
          moment.isMoment(this.state[prop])
        ) {
          searchRequest[prop] = moment.isMoment(this.state[prop])
            ? moment(this.state[prop]).format('MM/DD/YYYY')
            : Array.isArray(this.state[prop])
              ? this.state[prop].join()
              : this.state[prop];
        }
        else if ((prop === 'crashStartDate' || prop == 'crashEndDate') && this.state[prop] !== null) {
          searchRequest[prop] = moment(this.state[prop]).format('MM/DD/YYYY');
        }
      }
    }
    searchRequest.selectedReportIds = this.state.selectedCrashRowIds;
    searchRequest.selectedVehicleIds = this.state.selectedVehicleRowIds;
    searchRequest.selectAll = this.state.selectAll;
    searchRequest.searchBy = this.state.showResultsBy;
    return searchRequest;
  }

  getExportData = async () => {
    let dataRequest = this.buildSearchRequest();
    dataRequest.export = true;

    const response = await getExportData(urls.EXECUTE_CASE_STUDY_SEARCH, dataRequest);

    if (response.ok) {
      return response.data?.crashes || [];
    }
    return [];
  }

  doExport = async () => {
    let exportRequest = this.buildSearchRequest();
    exportRequest.export = true;

    const response = await doExport(urls.EXPORT_SERVERSIDE, exportRequest);

    if (response.ok) {
      return true;
    }
    return false;
  }

  clearFiltersAndResults = (): void => {
    this.setState({
      // results
      searchResults: [],
      crashSeverityTotals: { fatal: 0, injA: 0, injB: 0, injC: 0, pdo: 0, unk: 0, nr: 0, ns: 0 },
      // filters
      crashStartDate: null,
      crashEndDate: null,
      crashKey: '',
      highwayNumber: '',
      referencePostFrom: '',
      referencePostTo: '',
      latitudeFrom: '',
      latitudeTo: '',
      longitudeFrom: '',
      longitudeTo: '',
      sequenceOfEvents: [],
      firstHarmfulEvents: [],
      selectedCounty: -1,
      selectedCity: -1,
      selectedObjectType: -1,
      selectedDirectionOfTravel: [],
      locationLine1: '',
      locationLine2: '',
    });

    this.directionOfTravelRef.current.resetSelectedValues();
    this.sequenceOfEventsRef.current.resetSelectedValues();
    this.firstHarmfulEventRef.current.resetSelectedValues();
  }

  viewImage = (showOnlySelected?: boolean) => {
    let reports = this.state.showResultsBy == 'crashes' ? this.state.selectedCrashRowsOnPage : this.state.selectedVehicleRows;
    for (let i = 0; i < reports.length; i++) {
      const url = `/DocumentViewer?r=${reports[i].reportId}`;
      window.open(url, '_blank', 'width=1300,height=900');
    }
  };

  exportData = () => {
    //const dataToExport = this.resultsTable.getDataForSelectedRows();
    const dataToExport = this.state.selectedCrashRowsOnPage;
    this.props.showLoadingWithMessage(true, 'Submitting the export request...');
    Api.post(urls.EXPORT_SELECTED_RESULTS, JSON.stringify(dataToExport)).then(
      (response: ApiResponse<any>) => {
        this.props.showLoadingWithMessage(false);
      }
    );
  };


  getSelectedRecordSummaries = () => {
    // let reports = this.resultsTable.getRowsForData(true).data();
    let reports = this.state.showResultsBy == 'crashes'
      ? this.state.selectedCrashRowsOnPage
      : this.state.selectedVehicleRows;

    console.log({ reports });

    if (reports.length == 0) return '';

    let selectedInjurySummaries = {
      fatal: 0,
      injA: 0,
      injB: 0,
      injC: 0,
      pdo: 0,
      unk: 0,
      nr: 0,
      ns: 0,
    };

    for (let i = 0; i < reports.length; i++) {
      const report = reports[i];

      switch (report.crashSeverity) {
        case 'FATAL':
          selectedInjurySummaries.fatal += 1;
          break;
        case 'INJ-A':
          selectedInjurySummaries.injA += 1;
          break;
        case 'INJ-B':
          selectedInjurySummaries.injB += 1;
          break;
        case 'INJ-C':
          selectedInjurySummaries.injC += 1;
          break;
        case 'PDO':
          selectedInjurySummaries.pdo += 1;
          break;
        case 'UNK':
          selectedInjurySummaries.unk += 1;
          break;
        case 'N-R':
          selectedInjurySummaries.nr += 1;
          break;
        case 'N-S':
          selectedInjurySummaries.ns += 1;
          break;
      }
    }

    return (
      <React.Fragment>
        <h6>Selected Crash Severity Totals: </h6>
        {/* <label>Fatal: </label> {selectedInjurySummaries.fatal}
        <br />
        <label>Injured: </label> {selectedInjurySummaries.injured}
        <br />
        <label>PDO: </label> {selectedInjurySummaries.pdo} <br /> */}
        <label>FATAL:</label>
        <span style={{ paddingLeft: 5 }}>{selectedInjurySummaries.fatal}</span><br />
        <label>INJ-A:</label>
        <span style={{ paddingLeft: 5 }}>{selectedInjurySummaries.injA}</span><br />
        <label>INJ-B:</label>
        <span style={{ paddingLeft: 5 }}>{selectedInjurySummaries.injB}</span><br />
        <label>INJ-C:</label>
        <span style={{ paddingLeft: 5 }}>{selectedInjurySummaries.injC}</span><br />
        <label>PDO:</label>
        <span style={{ paddingLeft: 5 }}>{selectedInjurySummaries.pdo}</span><br />
        <label>UNK:</label>
        <span style={{ paddingLeft: 5 }}>{selectedInjurySummaries.unk}</span><br />
        <label>N-R:</label>
        <span style={{ paddingLeft: 5 }}>{selectedInjurySummaries.nr}</span><br />
        <label>N-S:</label>
        <span style={{ paddingLeft: 5 }}>{selectedInjurySummaries.ns}</span><br />
      </React.Fragment>
    );
  };

  handleCrashPagingCriteriaChange = (pagingCriteria: PagedResultsRequest) => {
    this.setState({ crashPagingCriteria: pagingCriteria as any }, () => {
      this.executeSearch();
    });
  };

  handleVehiclePagingCriteriaChange = (pagingCriteria: PagedResultsRequest) => {
    this.setState({ vehiclePagingCriteria: pagingCriteria as any }, () => {
      this.executeSearch();
    });
  };

  handleSelectCrashRow = (row: CaseStudySearchItem, checked: boolean) => {
    if (checked) {
      this.setState({
        selectedCrashRowsOnPage: this.state.selectedCrashRowsOnPage.concat(row),
        selectedCrashRowIds: this.state.selectedCrashRowIds.concat(row.id)
      });
    }
    if (!checked) {
      this.setState({
        selectedCrashRowsOnPage: this.state.selectedCrashRowsOnPage.filter(r => r.id != row.id),
        selectedCrashRowIds: this.state.selectedCrashRowIds.filter(x => x != row.id)
      });
    }
  }

  handleSelectVehicleRow = (row: CaseStudySearchItem, checked: boolean) => {
    if (checked) {
      this.setState({
        selectedVehicleRows: this.state.selectedVehicleRows.concat(row),
        selectedVehicleRowIds: this.state.selectedVehicleRowIds.concat(row.id)
      });
    }
    if (!checked) {
      this.setState({
        selectedVehicleRows: this.state.selectedVehicleRows.filter(r => r.id != row.id),
        selectedVehicleRowIds: this.state.selectedVehicleRowIds.filter(x => x != row.id)
      });
    }
  }

  handleSelectAllCheck = (checked: any) => {
    if (this.state.showResultsBy == 'crashes') {
      this.setState({
        selectAll: checked,
        selectedCrashRowsOnPage: checked ? this.props.searchResults.crashes : [],
        selectedCrashRowIds: checked ? this.props.searchResults.allReportIds : []
      });
    } else {
      this.setState({
        selectAll: checked,
        selectedVehicleRows: checked ? this.props.searchResults.vehicles : [],
        selectedVehicleRowIds: checked ? this.props.searchResults.allVehicleIds : []
      });
    }
  }

  caseStudyResultColumns: TableColumn<CaseStudySearchItem>[] = [
    {
      name: "Crash Key",
      selector: (row: CaseStudySearchItem) => row.accidentKey,
      sortField: "CrashKey",
      sortable: true,
      wrap: false,
      format: (row: CaseStudySearchItem) => {
        return (
          this.state.showResultsBy == "crashes" && (
            <Form.Check
              id={"chk" + row.id}
              type='checkbox'
              label={row.accidentKey}
              checked={this.state.selectedCrashRowIds.some(x => x == row.id)}
              onChange={(e) => this.handleSelectCrashRow(row, e.target.checked)}
            ></Form.Check>
          )
          || (
            <Form.Check
              id={"chk" + row.id}
              type='checkbox'
              label={row.accidentKey}
              checked={this.state.selectedVehicleRowIds.some(x => x == row.id)}
              onChange={(e) => this.handleSelectVehicleRow(row, e.target.checked)}
            ></Form.Check>
          )
        );
      }
    },
    // {
    //   name: 'Crash Key',
    //   selector: (row: CaseStudySearchItem) => row.accidentKey,
    //   sortField: "CrashKey",
    //   sortable: true,
    //   wrap: true,
    // }, 
    {
      name: "CRASH DATE",
      sortable: true,
      sortField: "CrashDate",
      wrap: true,
      selector: (row: CaseStudySearchItem) =>
        row?.accidentDateTime
          ? moment(row.accidentDateTime).format("MM/DD/yyyy")
          : ""
    },
    {
      name: 'Hwy',
      selector: (row: any) => row.highway,
      sortField: "Hwy",
      sortable: true,
      wrap: true,
    },
    {
      name: 'Ref. Post',
      selector: (row: any) => row.referencePost,
      sortField: "Id",
      sortable: false,
      wrap: true,
    },
    {
      name: 'Location',
      selector: (row: any) => row.location,
      sortField: "Id",
      sortable: true,
      wrap: true,
    },
    {
      name: 'Crash Sev',
      selector: (row: any) => row.crashSeverity,
      sortField: "Id",
      sortable: true,
      wrap: true,
    },
    {
      name: 'Severity',
      selector: (row: any) => row.severity,
      sortField: "Id",
      sortable: true,
      wrap: true,
    },
    {
      name: '# Injured',
      selector: (row: any) => {
        return this.state.dbToSearch == "private" ? row.numInjured : "";
      },
      sortField: "Id",
      sortable: true,
      wrap: true,
    },
    {
      name: '# Fatal',
      selector: (row: any) => {
        return this.state.dbToSearch == "private" ? row.numFatal : "";
      },
      sortField: "Id",
      sortable: true,
      wrap: true,
    },
    {
      name: 'Object Type',
      selector: (row: any) => row.objectType,
      sortField: "Id",
      sortable: true,
      wrap: true,
    },
    {
      name: 'City',
      selector: (row: any) => row.city,
      sortField: "Id",
      sortable: true,
      wrap: true,
    },
    {
      name: 'First Harmful Event',
      selector: (row: any) => row.firstHarmfulEvent,
      sortField: "Id",
      sortable: true,
      wrap: true,
    },
  ];

  exportColumnMaps: IExportColumnMap[] = [
    {
      columnName: 'Crash Key',
      propertyName: 'accidentKey'
    },
    {
      columnName: "CRASH DATE",
      propertyName: "accidentDateTime",
      convertMethod: (val) => moment(val).format("MM/DD/YYYY")
    },
    {
      columnName: 'Week Day',
      propertyName: 'accidentDayOfWeek',
    },
    {
      columnName: 'Mil. Time',
      propertyName: 'accidentTime',
    },
    {
      columnName: 'Ref. Post',
      propertyName: 'referencePost',
    },
    {
      columnName: 'Location',
      propertyName: 'location',
    },
    {
      columnName: 'Crash Sev',
      propertyName: 'crashSeverity',
    },
    {
      columnName: '# Injured',
      propertyName: 'numInjured',
      convertMethod: (val) => { return this.state.dbToSearch == "private" ? val : "" }
    },
    {
      columnName: '# Fatal',
      propertyName: 'numFatal',
      convertMethod: (val) => { return this.state.dbToSearch == "private" ? val : "" }
    },
    {
      columnName: 'Weather1',
      propertyName: 'weather1',
    },
    {
      columnName: 'Weather2',
      propertyName: 'weather2',
    },
    {
      columnName: 'Light Cond',
      propertyName: 'lightCondition',
    },
    {
      columnName: 'Multi Vehicle Crash Type',
      propertyName: 'mannerOfCrash',
    },
    {
      columnName: 'First Harmful Event',
      propertyName: 'firstHarmfulEvent',
    },
    {
      columnName: 'Road Surf Cond',
      propertyName: 'roadwaySurfaceCondition',
    },
    {
      columnName: 'Alcohol Involved',
      propertyName: 'alcoholInvolved',
    },
    {
      columnName: 'Drugs Involved',
      propertyName: 'drugsInvolved',
    },
    {
      columnName: 'Username',
      propertyName: 'username',
    },
  ];

  customStyles = {
    rows: {
      style: {
        minHeight: '72px', // override the row height
      },
    },
    headCells: {
      style: {
        paddingLeft: '8px', // override the cell padding for head cells
        paddingRight: '8px',
      },
    },
    cells: {
      style: {
        paddingLeft: '8px !important', // override the cell padding for data cells
        paddingRight: '8px',
        //marginLeft: '18px !important'
      },
    },
  };

  paginationComponentOptions = {
    selectAllRowsItem: true
  };

  render() {

    return (
      <div>
        <h3>Case Study Search</h3>
        <div className='divCaseStudyCriteria col-8'>
          <Form>
            <Form.Row>
              <Form.Group className='grpGridPadding' as={Col}>
                <Form.Label>Crash Key</Form.Label>
                <Form.Control
                  type="number"
                  min={100000000}
                  max={999999999}
                  value={this.state.crashKey}
                  onChange={this.handleCrashKeyChange}
                  onBlur={this.handleCrashKeyBlur}
                  onKeyDown={this.handleCrashKeyKeyDown}
                />
              </Form.Group>
              <Form.Group className='grpGridPadding' as={Col}>
                <Form.Label>Crash Date</Form.Label>
                <br />
                <DateRangePicker
                  onChange={(dates: Date[]) => {
                    this.setState({
                      crashStartDate: dates[0],
                      crashEndDate: dates[1],
                    })
                  }}
                  value={[this.state.crashStartDate, this.state.crashEndDate]}
                  rangeDivider=" to "
                  openCalendarOnFocus={false}
                  clearIcon={null}
                  maxDate={new Date(2100, 12, 12)}
                />
              </Form.Group>
              <Form.Group className='grpGridPadding' as={Col}>
                <Form.Label>Highway Number</Form.Label>
                <Form.Control
                  type='text'
                  value={this.state.highwayNumber}
                  onChange={(e) =>
                    this.handleStateChange(
                      'highwayNumber',
                      e.currentTarget.value
                    )
                  }
                />
              </Form.Group>
            </Form.Row>
            {this.state.showCrashKeyError && (
              <Form.Row>
                <Form.Group>
                  <Form.Label className='error'>
                    Crash Key Must be 9 numeric characters
                  </Form.Label>
                </Form.Group>
              </Form.Row>
            )}
            {this.state.dbToSearch == 'private' && (
              <Form.Row>
                <Form.Group className='grpGridPadding' as={Col}>
                  <Form.Label>Location Line</Form.Label>
                  <Row>
                    <Col>
                      <Form.Control
                        type='text'
                        value={this.state.locationLine1}
                        onChange={(e) =>
                          this.handleStateChange(
                            'locationLine1',
                            e.currentTarget.value
                          )
                        }
                      />
                    </Col>
                    <Col sm={1}>
                      <div style={{ marginLeft: '12px', marginTop: '6px' }}>
                        And
                      </div>
                    </Col>
                    <Col>
                      <Form.Control
                        type='text'
                        value={this.state.locationLine2}
                        onChange={(e) =>
                          this.handleStateChange(
                            'locationLine2',
                            e.currentTarget.value
                          )
                        }
                      />
                    </Col>
                  </Row>
                </Form.Group>
              </Form.Row>
            )}
            <Form.Row>
              <Form.Group className='grpGridPadding' as={Col}>
                <Form.Label>Reference Post</Form.Label>
                <Row>
                  <Col>
                    <Form.Control
                      type='text'
                      value={this.state.referencePostFrom}
                      onChange={(e) =>
                        this.handleStateChange(
                          'referencePostFrom',
                          e.currentTarget.value
                        )
                      }
                    />
                  </Col>
                  <Col sm={1}>
                    <div style={{ marginLeft: '-10px', marginTop: '6px' }}>
                      To
                    </div>
                  </Col>
                  <Col>
                    <Form.Control
                      type='text'
                      value={this.state.referencePostTo}
                      onChange={(e) =>
                        this.handleStateChange(
                          'referencePostTo',
                          e.currentTarget.value
                        )
                      }
                    />
                  </Col>
                </Row>
              </Form.Group>
              <Form.Group className='grpGridPadding' as={Col}>
                <Form.Label>Latitude Between</Form.Label>
                <Row>
                  <Col>
                    <Form.Control
                      type='text'
                      value={this.state.latitudeFrom}
                      onChange={(e) =>
                        this.handleStateChange(
                          'latitudeFrom',
                          e.currentTarget.value
                        )
                      }
                    />
                  </Col>
                  <Col sm={1}>
                    <div style={{ marginLeft: '-15px', marginTop: '6px' }}>
                      And
                    </div>
                  </Col>
                  <Col>
                    <Form.Control
                      type='text'
                      value={this.state.latitudeTo}
                      onChange={(e) =>
                        this.handleStateChange(
                          'latitudeTo',
                          e.currentTarget.value
                        )
                      }
                    />
                  </Col>
                </Row>
              </Form.Group>
              <Form.Group className='grpGridPadding' as={Col}>
                <Form.Label>Longitude Between</Form.Label>
                <Row>
                  <Col>
                    <Form.Control
                      type='text'
                      value={this.state.longitudeFrom}
                      onChange={(e) =>
                        this.handleStateChange(
                          'longitudeFrom',
                          e.currentTarget.value
                        )
                      }
                    />
                  </Col>
                  <Col sm={1}>
                    <div style={{ marginLeft: '-15px', marginTop: '6px' }}>
                      And
                    </div>
                  </Col>
                  <Col>
                    <Form.Control
                      type='text'
                      value={this.state.longitudeTo}
                      onChange={(e) =>
                        this.handleStateChange(
                          'longitudeTo',
                          e.currentTarget.value
                        )
                      }
                    />
                  </Col>
                </Row>
              </Form.Group>
            </Form.Row>
            <Form.Row>
              <Form.Group className='grpGridPadding' as={Col}>
                <Form.Label>Direction of Travel</Form.Label>
                <Multiselect
                  ref={this.directionOfTravelRef}
                  options={this.directionOfTravel} // Options to display in the dropdown
                  onSelect={(list, value) =>
                    this.handleMultiSelectAdd(
                      'selectedDirectionOfTravel',
                      value.value
                    )
                  } // Function will trigger on select event
                  onRemove={(list, value) =>
                    this.handleMultiSelectRemove(
                      'selectedDirectionOfTravel',
                      value.value
                    )
                  } // Function will trigger on remove event
                  isObject={true}
                  selectionLimit={2}
                  displayValue='text'
                  avoidHighlightFirstOption={true}
                />
              </Form.Group>
              <Form.Group className='grpGridPadding' as={Col}>
                <Form.Label>County</Form.Label>
                <Form.Control
                  as='select'
                  defaultValue={this.state.selectedCounty}
                  onChange={(e) =>
                    this.handleStateChange(
                      'selectedCounty',
                      e.currentTarget.value
                    )
                  }
                  value={this.state.selectedCounty}
                >
                  <option value={-1} key={-1}>
                    Select County
                  </option>
                  {this.state.counties.map((item, idx) => (
                    <option key={idx} value={item.name}>
                      {item.description}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
              <Form.Group className='grpGridPadding' as={Col}>
                <Form.Label>City</Form.Label>
                <Form.Control
                  as='select'
                  defaultValue={this.state.selectedCity}
                  onChange={(e) =>
                    this.handleStateChange(
                      'selectedCity',
                      e.currentTarget.value
                    )
                  }
                  value={this.state.selectedCity}
                >
                  <option value={-1} key={-1}>
                    Select Cities
                  </option>
                  {this.getFilteredCities().map((item, idx) => (
                    <option key={idx} value={item.name}>
                      {item.description}
                    </option>
                  ))}
                  ;
                </Form.Control>
              </Form.Group>
            </Form.Row>
            <Form.Row>
              <Form.Group className='grpGridPadding' as={Col}>
                <Form.Label>Object Type</Form.Label>
                <Form.Control
                  as='select'
                  defaultValue={this.state.selectedObjectType}
                  onChange={(e) =>
                    this.handleStateChange(
                      'selectedObjectType',
                      e.currentTarget.value
                    )
                  }
                  value={this.state.selectedObjectType}
                >
                  <option value={-1} key={-1}>
                    Select Object Type
                  </option>
                  {this.state.objectType.map((item, idx) => (
                    <option key={idx} value={item.name}>
                      {item.description}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
              <Form.Group className='grpGridPadding' as={Col}>
                <Form.Label>Sequence of Events</Form.Label>
                <Multiselect
                  ref={this.sequenceOfEventsRef}
                  options={this.state.eventData} // Options to display in the dropdown
                  onSelect={(list, value) =>
                    this.handleMultiSelectAdd('sequenceOfEvents', value.name)
                  } // Function will trigger on select event
                  onRemove={(list, value) =>
                    this.handleMultiSelectRemove('sequenceOfEvents', value.name)
                  } // Function will trigger on remove event
                  isObject={true}
                  displayValue='description'
                  avoidHighlightFirstOption={true}
                />
              </Form.Group>
              {this.state.dbToSearch == 'private' && (
                <Form.Group className='grpGridPadding' as={Col}>
                  <Form.Label>First Harmful Events</Form.Label>
                  <Multiselect
                    ref={this.firstHarmfulEventRef}
                    options={this.state.firstHarmfulEventData}
                    onSelect={(list, value) =>
                      this.handleMultiSelectAdd(
                        'firstHarmfulEvents',
                        value.name
                      )
                    }
                    onRemove={(list, value) =>
                      this.handleMultiSelectRemove(
                        'firstHarmfulEvents',
                        value.name
                      )
                    }
                    isObject={true}
                    displayValue='description'
                    avoidHighlightFirstOption={true}
                  />
                </Form.Group>
              )}
            </Form.Row>
            <div className='clearfix'></div>
            <div style={{ textAlign: 'right', borderTop: 'thin solid #dee1e3' }}>
              <div
                style={{
                  display: 'flex',
                  gap: 10,
                  justifyContent: 'flex-end',
                  alignItems: 'center',
                  marginTop: 5,
                }}
              >
                <select
                  onChange={(e) =>
                    this.handleStateChange('showResultsBy', e.currentTarget.value)
                  }
                  style={{
                    height: '40px',
                    position: 'relative',
                  }}
                  defaultValue="crashes"
                >
                  <option value='crashes'>
                    Show Crashes
                  </option>
                  <option value='vehicles'>
                    Show Vehicles
                  </option>
                </select>
                <select
                  onChange={(e) =>
                    this.handleStateChange('dbToSearch', e.currentTarget.value)
                  }
                  style={{
                    height: '40px',
                    position: 'relative',
                  }}
                  defaultValue="private"
                >
                  <option value='private'>
                    Private
                  </option>
                  <option value='public'>
                    Public
                  </option>
                </select>

                <Button
                  variant='primary'
                  onClick={() => this.clearFiltersAndResults()}
                >
                  Clear
                </Button>

                <Button
                  variant='primary'
                  className='btnCaseStudySearch'
                  onClick={() => this.executeSearch()}
                >
                  Search
                </Button>
              </div>
            </div>
          </Form>
        </div>

        {this.props.searchResults.crashes.length > 0 && (
          <div className="mt-4">
            <div
              className="mb-4"
              style={{
                border: 'thin solid #4280d8',
                padding: '15px',
                borderRadius: '20px',
              }}
            >
              <Grid style={{ marginLeft: '0px' }}>
                <Row>
                  <Col>
                    <div>
                      <h5>Summary</h5>
                      <label>FATAL:</label>
                      <span style={{ paddingLeft: 5 }}>{this.props.searchResults.summary.fatal}</span><br />
                      <label>INJ-A:</label>
                      <span style={{ paddingLeft: 5 }}>{this.props.searchResults.summary.injA}</span><br />
                      <label>INJ-B:</label>
                      <span style={{ paddingLeft: 5 }}>{this.props.searchResults.summary.injB}</span><br />
                      <label>INJ-C:</label>
                      <span style={{ paddingLeft: 5 }}>{this.props.searchResults.summary.injC}</span><br />
                      <label>PDO:</label>
                      <span style={{ paddingLeft: 5 }}>{this.props.searchResults.summary.pdo}</span><br />
                      <label>UNK:</label>
                      <span style={{ paddingLeft: 5 }}>{this.props.searchResults.summary.unk}</span><br />
                      <label>N-R:</label>
                      <span style={{ paddingLeft: 5 }}>{this.props.searchResults.summary.nr}</span><br />
                      <label>N-S:</label>
                      <span style={{ paddingLeft: 5 }}>{this.props.searchResults.summary.ns}</span><br />
                    </div>
                  </Col>
                  <Col></Col>
                  <Col>
                    {this.state.showSelectedResultDetails &&
                      this.getSelectedRecordSummaries()}
                  </Col>
                </Row>
              </Grid>
            </div>
            <Form.Row>
              &nbsp;&nbsp;&nbsp;&nbsp;
              &nbsp;&nbsp;&nbsp;&nbsp;
              <Form.Group controlId='chkSelectAll'>
                <Form.Check
                  type='checkbox'
                  label=' Select All'
                  checked={this.state.selectAll}
                  onChange={(e) => this.handleSelectAllCheck(e.target.checked)}
                />
              </Form.Group>

              &nbsp;&nbsp;&nbsp;&nbsp;
              <Button onClick={(e) => this.doExport()}>
                Export Results
              </Button>
              &nbsp;&nbsp;&nbsp;&nbsp;
              {/* <Button onClick={(e) => this.viewImage()}>
                    View All Reports
                  </Button>
                  &nbsp;&nbsp;&nbsp;&nbsp; */}
              <Button
                onClick={(e) =>
                  this.setState({ showSelectedResultDetails: true })
                }
              >
                Show Injury summaries for selected Reports
              </Button>
              &nbsp;&nbsp;&nbsp;&nbsp;
              <Button onClick={(e) => this.viewImage(true)}>
                View Selected Reports
              </Button>
            </Form.Row>
          </div>
        )}
        {this.state.showResultsBy == 'crashes' && (
          <PagedDatatable
            columns={this.caseStudyResultColumns}
            data={this.props.searchResults.crashes || []}
            loadingData={this.props.loading}
            totalDataItems={this.props.searchResults.crashTotal}
            exportTitle="Case Study Crash Search"
            exportFileName="Case Study Crash Search"
            exportColumnMaps={this.exportColumnMaps}
            pagingCriteria={this.state.crashPagingCriteria}
            paginationComponentOptions={this.paginationComponentOptions}
            updatePagedResults={this.handleCrashPagingCriteriaChange}
            getExportData={this.getExportData}
            customStyles={this.customStyles}
          ></PagedDatatable>
        )}
        {this.state.showResultsBy == 'vehicles' && (
          <PagedDatatable
            columns={this.caseStudyResultColumns}
            data={this.props.searchResults.vehicles || []}
            loadingData={this.props.loading}
            totalDataItems={this.props.searchResults.vehicleTotal}
            exportTitle="Case Study Vehicle Search"
            exportFileName="Case Study Vehicle Search"
            exportColumnMaps={this.exportColumnMaps}
            pagingCriteria={this.state.vehiclePagingCriteria}
            updatePagedResults={this.handleVehiclePagingCriteriaChange}
            getExportData={this.getExportData}
            hidePaging={true}
          ></PagedDatatable>
        )}
      </div>
    );
  }
}
const DataTableStyles = styled.div`
  padding-top: 10px;

  table {
    text-transform: uppercase;
  }
`;
export function mapStateToProps(state: any) {
  return {
    searchResults: state.CaseStudy.searchResults,
    loading: state.CaseStudy.loading
  };
}

const mapDispatchToProps = {
  showLoadingWithMessage,
  getSearchResults,
  setSelectedRowsChangedR
};

export default connect(mapStateToProps, mapDispatchToProps)(CaseStudySearch);
